//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {windVane} from '../../../utils/tmallGenius'
import imgBase64 from '../../../items/imgBase64.vue'
//
export default {
  components: {imgBase64,},
  data() {
    return {}
  },
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("手动连接设备")
    next()
  },
  created() {
  },
  methods: {
    /*------------------------------------------- 绑定方法 -------------------------------------------------------*/
    /*  点击下一步
      * */
    nextBtnClick() {
      //获取当前wifi，进行检查
      /*        windVane.getCurrentWifi().then(res => {
                  //alert(res.result);//当 res.result 为""时说明没有连接 wifi
                  if (res.indexOf("HomeMate_AP") >= 0) {*/
      this.$router.replace({
        path: "/connect/wifi/start",
        query: {
          name: this.$route.query.name
        }
      })
      /*            } else {
                    this.$vux.toast.show({
                      text: "请连接正确的wifi",
                      type: "cancel"
                    });
                  }
                }
              ).catch(e => {
                alert("failure: " + JSON.stringify(e));
              });*/
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/connect/wifi/TipsOfConnect.vue